import { Component, OnInit } from '@angular/core';
import { FilterService } from 'app/modules/selection-generic/services/filter.service';
import { SelectionGenericService } from 'app/modules/selection-generic/services/selection-generic.service';

@Component({
    selector: 'app-emp-filter',
    templateUrl: './emp-filter.component.html',
    styleUrls: ['./emp-filter.component.scss'],
    standalone: false
})
export class EmpFilterComponent implements OnInit {

  constructor(public filterService: FilterService,
              private selectionGenericService: SelectionGenericService) { }

  ngOnInit(): void {
  }

  SetAttribute(attributeList: any[]): void {
    this.selectionGenericService.employeeSelectionModal.AttributeList = attributeList;
  }

  SetAttributeModal(attributeModal: any[]): void {
    this.filterService.selectedAttribute = attributeModal;
  }

}
